import tw from "src/utils/tw";

interface Props {
  className?: string;
}

export function StripeIcon(props: Props) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 75 31"
      className={tw("w-10", props.className)}
    >
      <path
        d="M19.3,2.5l-5.2,1.1v16.8c0,3,2.3,5,5.4,5c1.8,0,2.9-0.4,3.6-0.7v-4c-0.6,0.4-3.9,1.3-3.9-1.8v-7.5h3.9V7.1h-3.9V2.5z
M29.8,8.6l-0.4-1.5H25V25h5.2V12.9c1.2-1.6,3.3-1.3,4-1.2V7.1C33.4,6.8,30.9,6.4,29.8,8.6z M40.5,0l-5.3,1.2v4.2l5.3-1.1V0z
M5.2,12.3c0-0.8,0.7-1.2,1.9-1.2c1.5,0,3.5,0.5,5.2,1.3V7.6C10.4,6.9,8.7,6.7,7,6.7c-4.2,0-7,2.1-7,5.9c0,5.7,7.9,4.8,7.9,7.3
c0,0.9-0.8,1.3-2,1.3c-1.8,0-4-0.7-5.6-1.6v4.7c1.9,0.8,3.9,1.2,5.6,1.2c4.3,0,7.3-1.9,7.3-5.6C13.1,13.5,5.2,14.7,5.2,12.3z
M75,16.2c0-5.3-2.6-9.5-7.6-9.5c-4.9,0-8,4.2-8,9.5c0,6.2,3.6,9.1,8.7,9.1c2.5,0,4.3-0.6,5.7-1.4v-3.9c-1.4,0.7-3,1.2-5,1.2
c-2.1,0-3.9-0.7-4.1-3.2h10.2C74.9,17.8,75,16.7,75,16.2z M64.7,14.2c0-2.3,1.4-3.3,2.7-3.3c1.3,0,2.7,0.9,2.7,3.3H64.7z M51.4,6.7
c-2.1,0-3.4,0.9-4.1,1.6l-0.2-1.3h-4.6V31l5.2-1.1v-5.9c0.7,0.5,1.9,1.3,3.6,1.3c3.8,0,7.1-2.7,7.1-9.4C58.5,10,55.1,6.7,51.4,6.7z
M50.2,21c-1.2,0-1.9-0.5-2.5-0.9v-7.7c0.6-0.6,1.3-1.1,2.5-1.1c1.9,0,3.3,2.1,3.3,4.8C53.4,18.9,52.1,21,50.2,21z M35.3,25h5.3V7.1
h-5.3V25z"
      />
    </svg>
  );
}
